import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dropfilterBrand' })
export class DropfilterBrand implements PipeTransform {
  transform(categories: any, searchText: any): any {
    if(categories == null){
      return null;
    }
    if (searchText == null) return categories;

    return categories.filter(function (category) {
      return category.service_provider_type_id.toLowerCase().indexOf(searchText) > -1;
      //return category.service_provider_type_id.toLowerCase().indexOf(searchText) === 0;
    })
  }
}




// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/-pipe/drop_filter/drop_filter_brand.pipe.ts